/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 2/18/13
 * Time: 11:34 AM
 * Layout view used as the main view for the content main page
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("content-templates/contentModule.tmpl");
    var Loader = require("ui/loader/Loader");

    var ContentModuleLayout = {};
    LE.module('LEContent', function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentModuleLayout = Marionette.Layout.extend({
            className: "content-module-wrapper",
            template: template,
            loader: null,
            loaderCounter: 0,
            regions: {
                mainRegion:'.content-main-region',
                toggledMainRegion:'.content-toggled-main-region',
                footerRegion:'.content-footer-region'
            },
            onRender: function () {
                this.mainRegion.on('show', function (view) {
                    $(this.toggledMainRegion.el).hide();
                    $(this.mainRegion.el).show();
                }, this);
                this.toggledMainRegion.on('show', function (view) {
                    $(this.mainRegion.el).hide();
                    $(this.toggledMainRegion.el).show();
                }, this);
            },
            showLoader: function(options) {
                if (this.loaderCounter === 0) {
                    this.loader = new Loader(_.extend({
                        permutation: Loader.PERMUTATION.A,
                        zIndex: 999999,
                        el: this.el
                    }, options));
                    this.loader.render();
                }
                this.loaderCounter++;
            },
            closeLoader: function() {
                this.loaderCounter--;
                if (this.loaderCounter === 0) {
                    this.loader.close();
                }

                this.loaderCounter = _.max([this.loaderCounter, 0]);
            },
        });

    });
    return ContentModuleLayout;
});
